import React from 'react';
import { View } from 'react-native';
import { useNavigation } from '@react-navigation/core';

import HeaderDefault from '../../components/HeaderDefault';
import BankAccountList from '../../components/BankAccountList';

import { styles } from './styles';

const WithdrawGPXAccountSelection = () => {
  const navigation = useNavigation();

  function onSelect(bankAccount) {
    navigation.navigate({ name: 'WithdrawGPX', params: { bankAccountId: bankAccount.id } });
  }

  return (
    <View style={{ flex: 1 }}>
      <HeaderDefault title={"Escolher conta"} />

      <BankAccountList onSelect={onSelect} />
    </View>
  );
}

export default WithdrawGPXAccountSelection;